import React from "react";
import Home from "../Homepage/home";
import Full from "../fullpagescroll/FullPage1";


function BackPages(){

return(


<div>
<Home/>
<Full></Full>

</div>

)


}

export default BackPages;